/**
 * MainMenu
 * @module components/MainMenu
 */


import React, { Component } from 'react';
import PropTypes from 'prop-types';
import style from './MainMenu.scss';
import { CurrentPathContext } from 'context/currentpath.context';

import Link from 'common/Link/Link';
import { DropDown, DropDownTitle, DropDownList } from 'components/DropDown';

/** Class representing the component. */
class MainMenu extends Component {

	static contextType = CurrentPathContext;

	/**
	 * Renders second level items (in dropdown)
	 * @param {Array} items 
	 */
	renderSecondLevelItems (items) {
		return (
			<ul className={style.secondLevel}>
				{ items.map((item, i) => {
					// Set class name based on if the link is the active path or not
					const linkClass = this.isItemCurrentPath(item) ? style.activeLink : '';

					return (
						<li className={linkClass} key={i}>
							<Link route={item.href}>
								<a dangerouslySetInnerHTML={{ __html: item.title }}></a>
							</Link>
						</li>
					);
				})}
			</ul>
		);
	}


	/**
	 * Renders a link with a dropdown
	 * @param {Object} link 
	 * @param {Number} i 
	 */
	renderLinkWithDropdown (link, i) {
		// Set class name based on if the link is the active path or not
		const linkClass = this.isItemCurrentPath(link) ? style.itemActive : style.item;

		return (
			<li className={linkClass} key={i}>
				<DropDown>
					<DropDownTitle href={link.href} clickable={true}>
						<span dangerouslySetInnerHTML={{ __html: link.title }}></span>
					</DropDownTitle>

					<DropDownList>
						{ link.items.map((item, i) => {
							// Set subclass name based on if the item is the active path or not
							const sublinkClass = this.isItemCurrentPath(item) ? style.dropdownItemActive : style.dropdownItem;

							return (
								<li key={i}>
									<Link route={item.href}>
										<a className={sublinkClass} dangerouslySetInnerHTML={{ __html: item.title }}></a>
									</Link>
									{ item.items && this.renderSecondLevelItems(item.items) }
								</li>
							);
						})}
					</DropDownList>
				</DropDown>
			</li>
		);
	}


	/**
	 * Gets the navigational links
	 */
	getLinks () {
		const links = this.props.links || [];

		return links.map((link, i) => {
			if (link.items) {
				return this.renderLinkWithDropdown(link, i);
			} else {
				// Set class name based on if the link is the active path or not
				const linkClass = this.isItemCurrentPath(link) ? style.itemActive : style.item;

				return (
					<li className={linkClass} key={i}>
						<Link route={link.href}>
							<a dangerouslySetInnerHTML={{ __html: link.title }}></a>
						</Link>
					</li>
				);
			}
		});
	}


	/**
	 * Check if the link adress correspond to the current path
	 * 
	 * @param {Object} item — The link object 
	 */
	isItemCurrentPath(item) {
		return (item.href === this.context.currentPath);
	}


	/**
	 * The render method
	 */
	render () {
		return (
			<nav className={style.mainMenu} aria-label="main-menu">
				<ul className={style.list}>
					{ this.getLinks() }
				</ul>
			</nav>
		);
	}
}


/** Prop types **/
MainMenu.propTypes = {
	links: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string,
			href: PropTypes.string
		})
	)
};


export default MainMenu;
